<template>
  <div class="max-w-screen-2xl mx-auto px-4 md:px-10">
    <div class="bg-white rounded-xl px-8 md:px-16 py-12 font-light">
      <diamond-detail-color-content :color="color" :colored="colored">
        <template #title>
          <base-headline class="!text-2xl mb-6 !normal-case !tracking-normal">
            {{ t("components.diamonds.details.color.title") }}:
            {{ initialColorLabel }}
          </base-headline>
        </template>
      </diamond-detail-color-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailColorContent from "@/components/diamonds/details/DiamondDetailColorContent.vue";

const { t } = useI18n();

const props = defineProps<{
  color: string | string[];
  colored: boolean;
}>();

const colors = [
  { key: "j", label: "J" },
  { key: "i", label: "I" },
  { key: "h", label: "H" },
  { key: "g", label: "G" },
  { key: "f", label: "F" },
  { key: "e", label: "E" },
  { key: "d", label: "D" },
];

const initialColorLabel = computed(() => {
  const colorValue = Array.isArray(props.color) ? props.color[0] : props.color;
  if (!colorValue) return "";
  const found = colors.find((c) => c.key === colorValue.toLowerCase());
  return found ? found.label : colorValue;
});
</script>

<style scoped></style>
